/**
  Experimental new component - will move to UCL if this is successful

  Intended as a positional component only - an invisible container of child
  components that allows for width, padding and alignment adjustments

*/
import styled from 'styled-components';

export interface ContainerProps {
  children?: React.ReactNode;
  width?: string;
  maxWidth?: string;
  padding?: string;
  align?: 'left' | 'center' | 'right';
}

export const ContainerElement = styled.div<ContainerProps>`
  display: grid;
  padding: ${props => props.padding};
  width: ${props => props.width};
  max-width: ${props => props.maxWidth};
  justify-self: ${props => props.align};
`;

export function Container({ children, ...props }: ContainerProps) {
  return (
    <ContainerElement {...props} data-testid="Container">
      {children}
    </ContainerElement>
  );
}
